<template>
  <div class="card">
    <div
      class="card-header pb-0 d-flex align-items-center justify-content-between"
    >
      <h5 v-if="editMode">{{ $t("edit_targetgroup") }}</h5>
      <h5 v-else>{{ title }}</h5>
    </div>
    <!-- <LanguagePicker v-model="selectedLanguage" /> -->
    <div class="card-body">
      <div class="form theme-form">
        <div class="row">
          <div class="col-12 col-xl-6 row">
            <div v-if="!saveable" class="col-12">
              <div class="mb-3 w-100">
                <label>{{ $t("search_existing_targetgroup") }}</label>
                <div class="custom-autocomplete-container">
                  <v-autocomplete
                    clearable
                    min-width="300"
                    class="custom-autocomplete"
                    :items="targetgroups"
                    v-model="selectedFilter"
                    @change="applyTargetAudienceConfiguration()"
                    clear-icon="fas fa-times"
                    hide-details="auto"
                    dense
                    item-text="name"
                    return-object
                  >
                    <template v-slot:append>
                      <v-icon>fa fa-search</v-icon>
                    </template>
                    <!-- <template v-slot:clear>
                      <v-icon>fas fa-times</v-icon>
                    </template> -->
                    <template v-slot:selection="{ item }">
                      {{ item.name }}
                    </template>
                    <template v-slot:item="{ item }">
                      {{ item.name }}
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>

            <div class="col-12 py-0">
              <div class="mb-3 w-100">
                <label>{{ $t("designation") }}*</label>
                <v-text-field
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  type="text"
                  v-model="filter.name"
                ></v-text-field>
              </div>
            </div>
            <div class="col-12 py-0">
              <div class="mb-3">
                <label>{{$t("app")}}*</label>
                <v-select class="mt-0 pt-0" v-model="filter.app" :items="apps"
                  append-icon="" hide-details>
                  <template slot="item" slot-scope="data">
                    <img style="width:40px;height: 40px;"  class="rounded-lg app-icon mr-5" :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                  </template>
                  <template class="py-2" slot='selection' slot-scope="data">
                    <img style="width:40px;height: 40px;"  class="rounded-lg app-icon my-1 mr-5" :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                  </template>
                </v-select>
              </div>
            </div>

            <div
              v-show="$rights.includes('TENANT_INDEPENDENCE')"
              class="col-12 py-0 align"
            >
              <div class="mb-3 w-100">
                <label>{{ $t("tenant") }}</label>
                <v-select
                  class="mt-0 pt-0"
                  v-model="filter.tenant"
                  :items="tenants"
                  item-text="name"
                  item-value="id"
                  append-icon=""
                  hide-details
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="col-6 py-0 align" v-for="field in fields" :key="field.name">
              <div class="mb-2 w-100">
                <label>{{ $t(field.name) }}</label>&nbsp;
                <v-tooltip bottom v-if="field.tooptip != null && field.tooltip != ''">
                  <template v-slot:activator="{ on }">
                    <v-icon size="16" v-on="on">fa fa-info-circle</v-icon>
                  </template>
                  <span>{{ $t(field.tooltip) }}</span>
                </v-tooltip>

                <v-text-field
                  v-if="field.type == 'String' || field.type == 'Text'"
                  type="text"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter[field.name]"
                ></v-text-field>

                <v-text-field
                  v-if="field.type == 'Integer' || field.type == 'Number'"
                  type="number"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter[field.name]"
                ></v-text-field>

                <v-select
                  v-if="field.type == 'Language'"
                  class="mt-0 pt-0"
                  v-model="filter[field.name]"
                  :items="possiblelanguages"
                  item-text="name"
                  item-value="enum"
                  append-icon=""
                  hide-details
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                </v-select>

                <input
                  v-if="field.type == 'LocalDateTime' || field.type == 'DateTime'"
                  class="form-control digits"
                  type="datetime-local"
                  v-model="filter[field.name]"
                />

                <v-textarea
                  v-if="field.type == 'TextArea'"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter[field.name]"
                ></v-textarea>

                <v-autocomplete
                  v-if="field.type == 'ETSMake'"
                  class="mt-0 pt-0"
                  v-model="filter[field.name]"
                  :items="makes"
                  item-text="name"
                  item-value="name"
                  append-icon=""
                  hide-details
                  @change="fetchModels()"
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item }}
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  v-if="field.type == 'ETSModel'"
                  class="mt-0 pt-0"
                  v-model="filter[field.name]"
                  :items="models"
                  item-text="name"
                  item-value="name"

                  append-icon=""
                  hide-details
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item }}
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  v-if="field.type == 'APISelect'"
                  class="mt-0 pt-0"
                  v-model="filter[field.name]"
                  :items="selectValues[field.name]"
                  :search="filter[field.name + '_name']"
                  :placeholder="filter[field.name + '_name']"
                  item-text="name"
                  item-value="id"
                  append-icon=""
                  hide-details
                  :search-input.sync="searchSelectValues[field.name]"
                  @keyup="fetchAPISelectValues(field, searchSelectValues[field.name])"
                  @change="selectFetchAPIValue(field, $event)"
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                </v-autocomplete>
              </div>
            </div>
            <!-- <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("membersince") }}</label>
                <input
                  class="form-control digits"
                  type="datetime-local"
                  v-model="filter.memberSince"
                />
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-2 w-100">
                <label>{{ $t("createdPostsCount") }}</label>
                <v-text-field
                  type="number"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter.createdPostsCount"
                ></v-text-field>
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("createdTripsCount") }}</label>
                <v-text-field
                  type="number"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter.createdTripsCount"
                ></v-text-field>
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("audienceVehicleCount") }}</label>
                <v-text-field
                  type="number"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter.audienceVehicleCount"
                ></v-text-field>
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("makes") }}</label>
                <v-autocomplete
                  class="mt-0 pt-0"
                  v-model="filter.audienceVehicleMake"
                  :items="makes"
                  item-text="name"
                  item-value="name"
                  append-icon=""
                  hide-details
                  @change="fetchModels()"
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item }}
                  </template>
                </v-autocomplete>
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("models") }}</label>
                <v-autocomplete
                  class="mt-0 pt-0"
                  v-model="filter.audienceVehicleModel"
                  :items="models"
                  item-text="name"
                  item-value="name"
                  append-icon=""
                  hide-details
                  @change="fetchModels()"
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item }}
                  </template>
                </v-autocomplete>
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("language") }}</label>
                <v-select
                  class="mt-0 pt-0"
                  v-model="filter.language"
                  :items="possiblelanguages"
                  item-text="name"
                  item-value="enum"
                  append-icon=""
                  hide-details
                >
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                  <template slot="selection" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("lastCreatedPostFrom") }}</label>
                <input
                  class="form-control digits"
                  type="datetime-local"
                  v-model="filter.lastCreatedPostFrom"
                />
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("lastCreatedPostTo") }}</label>
                <input
                  class="form-control digits"
                  type="datetime-local"
                  v-model="filter.lastCreatedPostTo"
                />
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("audienceVehicleYearFrom") }}</label>
                <v-text-field
                  type="number"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter.audienceVehicleYearFrom"
                ></v-text-field>
              </div>
            </div>
            <div class="col-6 py-0 align">
              <div class="mb-3 w-100">
                <label>{{ $t("audienceVehicleYearTo") }}</label>
                <v-text-field
                  type="number"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  dence
                  v-model="filter.audienceVehicleYearTo"
                ></v-text-field>
              </div>
            </div>
            <div class="col-12 py-0">
              <div class="mb-3">
                <label>{{ $t("hashtags") }}</label>&nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon size="16" v-on="on">fa fa-info-circle</v-icon>
                  </template>
                  <span>{{ $t("targetgroup_hashtags_explanation") }}</span>
                </v-tooltip>
                <v-textarea
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  v-model="filter.likedHashTags"
                ></v-textarea>
              </div>
            </div> -->
          </div>
          <div class="col-12 col-xl-6">
            <div class="col-12 py-0 px-0 px-md-3">
              <label>{{ $t("location") }}</label>
              <vue-google-autocomplete
                id="map"
                classname="form-control"
                :placeholder="$t('search_address')"
                types="address"
                v-on:placechanged="googleAutocompleteChanged"
              >
              </vue-google-autocomplete>
              <l-map
                ref="map"
                @click="addMarker"
                :zoom="map.zoom"
                :center="[map.center.latitude, map.center.longitude]"
                style="height: 300px; width: 100%; z-index: 1"
              >
                <l-tile-layer :url="map.url" :attribution="map.attribution" />
                <l-marker
                  v-for="(marker, index) in map.markers"
                  :key="index"
                  :lat-lng="marker"
                  @click="removeMarker(index)"
                />
                <l-circle
                  v-for="(marker, index) in map.markers"
                  :key="index"
                  :lat-lng="marker"
                  :radius="filter.radius * 1000"
                  :color="'#2F3452'"
                />
              </l-map>
              <div class="col-12 px-0">
                <label>{{ $t("radius_in_km") }}</label>
                <v-text-field
                  type="number"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  hide-details="auto"
                  dence
                  v-model="filter.radius"
                ></v-text-field>
              </div>
            </div>
          </div>
        </div>
        <div v-if="saveable">
          <button
            style="float: right"
            @click="save(filter)"
            class="btn btn-primary"
            type="button"
            data-bs-original-title=""
            title=""
          >
            {{ $t("save") }}
          </button>
          <button
            class="btn btn-secondary mr-2"
            style="float: right"
            @click="$routerBack()"
          >
            {{ $t("cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "FilterForm",

  components: {
        VueGoogleAutocomplete
    },

  props: {
    // filter: Object,
    title: String,
    saveable: Boolean,
    save: Function,
    value: Object,
  },

  computed: {
    filter: {
      get() {
        return this.value;
      },
      set(val) {
        console.log(val);
        this.$emit('input', val);
      }
    }
  },

  watch:{
    "filter.latitude":{
      handler(val){
        if (this.onfetch && this.filter.id != null) {
            this.onfetch = false;
            if (this.filter.latitude != null && this.filter.longitude != null) {
              this.map.markers.push({
                lat: this.filter.latitude,
                lng: this.filter.longitude,
              });
              this.map.center.latitude = this.filter.latitude;
              this.map.center.longitude = this.filter.longitude;
            } else {
              navigator.geolocation.getCurrentPosition((loc) => {
                this.map.center.latitude = loc.coords.latitude;
                this.map.center.longitude = loc.coords.longitude;
              });
            }
        }
      },
      immediate:true,
    },
    "filter.app":{
      handler(val){
        if(val == null) return;
        // Show App specific fields from configuration
        try {
          const targetAudienceConfiguration = JSON.parse(val.targetAudienceConfiguration);
          this.fields = targetAudienceConfiguration.fields;
        } catch (error) {
          console.error(error);
          this.$noty.error(this.$t("error_with_target_audience_configuration"));
        }
        this.filter.appId = val.id;

        if(val.packageName == "com.enjoythestreet"){
          this.fetchMakes();
        }

        for (let i = 0; i < this.fields.length; i++) {
          const field = this.fields[i];
          this.fetchAPISelectValues(field);
        }
      },
      immediate:true,
    },
    "filter.audienceVehicleMake":{
      handler(val){
        if(val == null || val == ""){
          this.filter.audienceVehicleModel = null;
          return;
        }
        this.fetchModels();
      },
      immediate:true,
    }
  },


  data() {
    return {
      saveable: false,

      selectedLanguage: this.$locale,

      onfetch: true,

      selectedFilter: null,

      languages: [],
      makes: [],
      models: [],
      tenants: [],
      apps: [],
      fields: [],

      // Select Values for generic comboboxes
      selectValues: {},
      searchSelectValues: {},
      selectedSelectValues: {},

      fixedTargetGroupAttributes: ["id", "appId", "tenant", "targetAudienceConfiguration", "createdAt", "createdBy", "editedAt", "editedBy", "longitude", "latitude", "radius", "deleted", "name", "app", "createdAtFormatted", "editedAtFormatted", "tenantId"],

      map: {
        center: {
          latitude: 0,
          longitude: 0,
        },
        zoom: 10,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        markers: [],
      },
    };
  },

  mounted() {
    this.fetchTenants();
    this.fetchLanguages();
    this.fetchApps();
    this.fetchTargetgroups();
    setTimeout(() => {
        this.convertHashtags();
    }, 500);

    setTimeout(() => {
      if (
        (this.filter.latitude == null && this.filter.longitude == null) ||
        (this.filter.latitude == "" && this.filter.longitude == "")
      ) {
        navigator.geolocation.getCurrentPosition((loc) => {
          this.map.center.latitude = loc.coords.latitude;
          this.map.center.longitude = loc.coords.longitude;
        });
      }
    }, 2000);
  },

  methods: {
    convertHashtags(){
        if(this.filter.likedHashTags == "") return;
        const arr = this.filter.likedHashTags;
        this.filter.likedHashTags = arr.join(', ');
    },
    fetchTargetgroups(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get("/api/targetaudience", {
          params: {
            limit: 500,
          },
        })
        .then(function (response) {
          _this.targetgroups = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    addMarker(event) {
      if (this.map.markers.length >= 1) {
        this.removeMarker();
      }
      this.map.markers.push(event.latlng);
      this.filter.longitude = this.map.markers[0] == undefined ? null : this.map.markers[0].lng;
      this.filter.latitude = this.map.markers[0] == undefined ? null : this.map.markers[0].lat;
    },
    removeMarker() {
      this.map.markers.splice(0, 1);
      this.filter.longitude = this.map.markers[0] == undefined ? null : this.map.markers[0].lng;
      this.filter.latitude = this.map.markers[0] == undefined ? null : this.map.markers[0].lat;
    },
    fetchLanguages(resetPage = false) {
      var _this = this;
      this.$axios
        .get("/api/language/all")
        .then(function (response) {
          _this.languages = response.data;
          _this.convertLanguages(_this.languages);
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchApps() {
      var _this = this;
      this.$axios
        .get("/api/app/")
        .then(function(response) {
          _this.apps = response.data.content;
        })
        .catch(this.onError);
    },
    fetchMakes() {
      var _this = this;
      this.$axios
        .get("/api/etsdata/makes")
        .then(function (response) {
          _this.makes = response.data.data;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchModels() {
      var _this = this;
      this.$axios
        .get("/api/etsdata/models/" + this.filter.audienceVehicleMake)
        .then(function (response) {
          _this.models = response.data.data;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchAPISelectValues(field, search = null) {
      if(field.url == null) return;
      var _this = this;
      var suffix = search == null ? "" : "?search=" + search;
      if(field.url.includes("?")) suffix = suffix.replace("?", "&");
      this.$axios
        .post("/api/foreign", {url: field.url + suffix, appId: "" + this.filter.app.id})
        .then(function (response) {
          if(field.responseProperty == null){
            _this.selectValues[field.name] = response.data;
          }else{
            _this.selectValues[field.name] = response.data[field.responseProperty];
          }

          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    selectFetchAPIValue(field, event){
      // this.filter[field.name]
      for (let i = 0; i < this.selectValues[field.name].length; i++) {
        const selectableValue = this.selectValues[field.name][i];
        if(selectableValue.id == event){
          this.filter[field.name] = event;
          this.filter[field.name + "_name"] = selectableValue.name;
          break;
        }
      }
    },
    convertLanguages(languages) {
      const lnlist = [];
      for (var i in languages) {
        var language = {};
        var ln = languages[i].language;

        language.enum = languages[i].language;
        language.name = this.$t(languages[i].language);
        language.flag = languages[i].flag;
        language.shortForm = languages[i].shortForm;
        lnlist.push(language);
      }
      this.possiblelanguages = lnlist;
    },
    fetchTenants(resetPage = false) {
      var _this = this;
      this.$axios
        .get("/api/tenant")
        .then(function (response) {
          _this.tenants = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    applyTargetAudienceConfiguration(){
      if(this.selectedFilter == null){
        this.filter = null;
        return;
      }
      this.filter = Object.assign({}, this.selectedFilter);

      setTimeout(() => {
        const targetAudienceConfiguration = JSON.parse(this.selectedFilter.targetAudienceConfiguration);
        for (const [key, value] of Object.entries(targetAudienceConfiguration)) {
          if(this.fixedTargetGroupAttributes.includes(key)) continue;
          this.filter[key] = value;
        }
        this.$forceUpdate();
      }, 300);
    },  
    googleAutocompleteChanged(data){
        if (this.map.markers.length >= 1) { this.removeMarker() }
        var coordinates = {
            lat: data.latitude,
            lng: data.longitude
        };
        this.map.markers.push(coordinates);
        this.targetLocation.longitude = data.longitude;
        this.targetLocation.latitude = data.latitude;
        var _this = this;
        Vue.nextTick(() => {
            _this.map.center = {
                latitude: data.latitude,
                longitude: data.longitude
            };
            _this.map.zoom = 16;
            _this.$refs.map.mapObject.panTo(_this.map.center);
        });
    }
  },
};
</script>

<style scoped>
.custom-autocomplete-container
  > .custom-autocomplete
  .v-input__icon.v-input__icon--clear {
  margin-right: 5px;
  transform: scale(0.54);
}

.card-header h1,
.card-header > h2,
.card-header > h3,
.card-header > h4,
.card-header > h5 {
  color: #2f3452 !important;
}
</style>